import { PropsWithChildren } from "react";
import css from "./Section.module.scss";

export function Section(props: PropsWithChildren & { id?: string }) {
  return (
    <section id={props.id} className={css.Section}>
      {props.children}
    </section>
  );
}
export function SectionTitle(props: PropsWithChildren) {
  return <div className={css.SectionTitle}>{props.children}</div>;
}
export function SectionHeader(props: PropsWithChildren) {
  return <div className={css.SectionHeader}>{props.children}</div>;
}
export function SectionSubTitle(props: PropsWithChildren) {
  return <div className={css.SectionSubTitle}>{props.children}</div>;
}

Section.Header = SectionHeader;
Section.Title = SectionTitle;
Section.SubTitle = SectionSubTitle;
